module.exports = __webpack_public_path__ + "img/logo-light.b1f83746.png";